import * as zExt from "@redotech/rpc/ext";
import * as z from "zod/v4";

const klaviyoMetricSchema = z.object({
  name: z.string(),
  lastFired: z.string().nullable(),
});

export const klaviyoMetricsHealthCheck = {
  name: "klaviyoMetricsHealthCheck" as const,
  input: z.object({
    teamId: zExt.objectId(),
    startHealthCheck: z.boolean().optional(),
    workflowId: z.string().optional(),
  }),
  output: z.object({
    scanned: z.boolean(),
    metrics: z.array(klaviyoMetricSchema),
    workflowId: z.string(),
  }),
};
